<template>
  <div>
    <Loader v-if="appLoading" />

    <div v-else>
      <Header />

      <main class="container">
        <router-view />
      </main>

      <PasswordModal
        v-if="changePasswordDialog"
        @close="!changePasswordDialog"
        :request="changePassword"
        necessarily
      />

    </div>
  </div>
</template>

<script>
import 'swiper/swiper-bundle.min.css'
import Header from "@/layouts/Header";
import Loader from "@/layouts/Loader.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import PasswordModal from "@/components/Modals/PasswordModal.vue";
import { updatePassword } from "@/api/users.js";

import Auth from "@/utils/auth.js";

export default {
  components: {
    Header,
    Loader,
    PasswordModal
  },
  async mounted() {
    await Auth.checkToken()
    this.getActiveUser(Auth.userId());
    this.getOptions();
    this.getUsers();
    this.getPassengers();
    this.getDepartments();
    this.getFiliations();
    this.getContracts();
    this.getCards();
    this.getReturnReasons();
  },
  methods: {
    ...mapActions("users", ["getActiveUser", "getUsers", "getPassengers"]),
    ...mapActions("options", ["getOptions"]),
    ...mapActions("departments", ["getDepartments"]),
    ...mapActions("filiations", ["getFiliations"]),
    ...mapActions("contracts", ["getContracts"]),
    ...mapActions("cards", ["getCards"]),
    ...mapActions("returnReasons", ["getReturnReasons"]),
    сheckAccesses() {
      const isAdminPanel = this.$route.path.includes("admin-panel");
      const isOrders = this.$route.path.includes("order") || this.$route.name === "Orders";

      if (this.isSuperAdmin || this.$route.name === "User") {
        // супер админу и на странице профиля редирект не требуется
        return;
      } else if (
        !isAdminPanel &&
        this.isAdmin &&
        !(this.isLogist || this.isLeader || this.isOSRStaff)
      ) {
        // если страница не 'админ.панель' и пользователь - админ и не имеет дополнительных ролей то редирект на 'админ.панель'
        this.$router.push("/admin-panel/admins");
      } else if (
        isAdminPanel &&
        this.$route.name.includes('Passenger') &&
        (this.isLogist || this.isOSRStaff)
      ) {
        // логистам и сотрудникам ОСР можно на страницу внешних пассажиров
        return;
      } else if (
          isAdminPanel &&
          this.$route.name.includes('Contracts') &&
          (this.isLogist )
      ) {
        // логистам можно на страницу договоров
        return;
      } else if (
          isAdminPanel &&
          this.$route.name.includes('Cards') &&
          (this.isLogist || this.isSuperAdmin)
      ) {
        // суперадминам и логистам можно на страницу карт
        return;
      } else if (!isOrders && !(this.isAdmin || this.isLogist)) {
        // если страница не 'заявки' и пользователь не админ то редиект на 'заявки'
        this.$router.push({ name: "Orders" });
      }
    },
    async changePassword(passwordData) {
      await updatePassword(
        this.activeUser.id,
        passwordData?.newPassword,
        passwordData?.repeatPassword,
      ).then (res => {
        console.log(res);
        Auth.logout()
        this.$router.push({ name: "Login", params: { withoutConfrim: true } });
      })
    },
  },
  computed: {
    ...mapState("users", ["activeUser", "activeUserLoading"]),
    ...mapState("options", ["optionsLoading"]),
    ...mapGetters("users", [
      "isAdmin",
      "isSuperAdmin",
      "isLogist",
      "isLeader",
      "isOSRStaff",
    ]),
    appLoading() {
      return this.optionsLoading || this.activeUserLoading;
    },

    changePasswordDialog() {
      return this.activeUser.should_change_password
    }
  },
  watch: {
    $route(to, from) {
      if (!this.appLoading) {
        if (this.$route.name === "User") {
          this.$route.meta.breadcrumb.to = from.fullPath;
        }

        this.сheckAccesses();
      }
    },
    appLoading(val) {
      if (!val) {
        this.сheckAccesses();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  max-width: 1419px;
  width: 95%;
  margin: 0 auto 80px;
  height: 100%;
  min-height: calc(100vh - 225px);
}
</style>
